import { ref } from 'vue'

export default () => ({
  activeSubstances: ref([])
})
